import { Response, requestGet, requestPost } from '../request';
import apiPath from './apiPath';
import { ottoPayRequest } from '@/utils/ottoPay';
import vuexStore from '@/store/index';

// Add device info to order payload
function withDeviceInfo(payload: any) {
  return {
    ...payload,
    device_id: localStorage.getItem('deviceId') || '',
    device_email: vuexStore.state.currentUser ? vuexStore.state.currentUser.Email : ''
  };
}

const api = {
  BoCalCulateOrder(payload) {
    return requestPost(apiPath.BO_CALCULATE_ORDER.path, payload);
  },
  BoConsultOrder(payload: any) {
    return requestPost(apiPath.CONSULT_ORDER.path, withDeviceInfo(payload));
  },
  BoPostPayOrder(payload) {
    return requestPost(apiPath.SUBMIT_POSTPAY_ORDER.path, withDeviceInfo(payload));
  },
  BoPostPayBill(payload) {
    return requestPost(apiPath.CONSULT_POSTPAY_BILL.path, payload);
  },
  GetPosMenuList(payload) {
    return requestGet(apiPath.MENU_LIST.path, payload);
  },
  GetPosOrderStatus(payload, paymentMethod = ''): Promise<Response> {
    if (paymentMethod === 'ottopay-h2h') {
      return ottoPayRequest('status', payload).then(result => ({ data: { code: '200', message: 'SUCCESS', data: { status: result.state === 'completed' ? 'PAYMENT_SUCCESS' : 'INIT' } } }));
    }
    let path = apiPath.GET_MID_STATUS.path
    if (paymentMethod === 'CIMB') {
      path = apiPath.GET_CIMB_STATUS.path
    } else if (paymentMethod === 'Astrapay') {
      path = apiPath.GET_ASTRA_PAY_STATUS.path
    }
    return requestGet(path, payload);
  },
  BoUpdateBillStatus(payload) {
    return requestPost(apiPath.UPDATE_BILL_STATUS.path, payload);
  },
  BoConsultOtherOrder(payload) {
    return requestPost(apiPath.CONSULT_OTHER_ORDER.path, withDeviceInfo(payload));
  },
  BoPosOrder(payload) {
    return requestPost(apiPath.POS_ORDER.path, withDeviceInfo(payload));
  },
  GetProcessingFee(payload) {
    return requestGet(apiPath.GET_PROCESSING_FEE.path, payload);
  },
};

export default api;
